<template>

  <div class="menu-title">
    <p>Jjigae (Korean Stew, 찌개) Dish</p>
  </div>


  <div class="Jjigae-container-1">

    <div class="Jjigae-grid-1">
      <div>
        <img class="menu-pic" src="../assets/JjigaeKimchi.jpg">
      </div>
      <div class="menu-text">
        <p>Kimchi Tofu (김치찌개)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>

    <div class="Jjigae-grid-2">
      <div>
        <img class="menu-pic" src="../assets/JjigaeDoenjang.jpg">
      </div>
      <div class="menu-text">
        <p>Tofu Bean Paste (된장찌개)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>

    <div class="Jjigae-grid-3">
      <div>
        <img class="menu-pic" src="../assets/JjigaeSoftTofu.jpg">
      </div>
      <div class="menu-text">
        <p>Soft Tofu Stew (순두부찌개)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>

  </div>


  <div class="Jjigae-container-2">

    <div class="Jjigae-grid-4">
      <div>
        <img class="menu-pic" src="../assets/RiceCurry.jpg">
      </div>
      <div class="menu-text">
        <p>Curry Rice (카레)</p>
        <!-- <p>9.99</p> -->
      </div>
    </div>
   
  </div>


</template>


<script>

  export default {
    name: 'JjigaeBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }


  .Jjigae-container-1, .Jjigae-container-2 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    color: darkblue;
  }


  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>